import { TourStep } from '../../models/tour.model';

export const MARKET_COMPARE_TOUR: TourStep[] = [
  {
    title: 'About Market Compare',
    intro: `
        <p>Welcome to <b>Market Compare</b> in Semeris Docs!</p>
        <p>Here, you can create spreadsheet-like reports to <b>compare many deals</b> at once.</p>
        <p>Each column is a <b>value</b> or some <b>language</b> extracted from deal documents.</p>
        <p><i>Let's look at how it enhances your market analysis.</i></p>
      `,
  },
  {
    title: 'Topics and Market Compare',
    element: 'h2.mat-card-title',
    intro: `
        <p>Each sheet in Market Compare is called a <b>Topic</b>.</p>
        <p>Topics are multi-use. They can be used as <b>spreadsheets</b>, but also as <b>blocks of checklists</b> used to review a deal.</p>
        <p>Clicking on the name of the topic here let's you <b>name</b> it.</p>
      `,
  },
  {
    title: 'Quick Preview',
    element: '.market-comparison-actions div',
    intro: `
        <p><b>Quick Preview</b> speeds things up by showing only the first 50 deals.</p>
        <p>Disable it to see all deals, but expect longer <b>load times</b>.</p>
        <p>Switching topics or filters? Quick Preview auto-enables to speed things up again.</p>
        <p><i>Limit columns to 10-12 for best speed.</i></p>
      `,
  },
  {
    title: 'Switching Deal Filters',
    element: 'semeris-deal-filter-selector',
    intro: `
          <p>This dropdown lets you refine which deals appear on your spreadsheet.</p>
          <p><i><b>Note!</b> Quick Preview is reenabled when you switch filters.</i></p>
      `,
  },
  {
    title: 'Three-dot Menu',
    element: '.market-comparison-actions button:nth-of-type(2)',
    intro: `
        <p>As usual in Semeris Docs, the three-dot <i class="material-icons">more_vert</i> menu includes more options.</p>
        <p>Allows <b>exporting data and language</b>, <b>adjusting row height</b>, <b>reordering columns</b>, and more.</p>
      `,
  },
  {
    title: 'Adding Columns',
    element: 'semeris-column-add-menu',
    intro: `
        <p>Use the <i class="material-icons">add</i> icon to extend the sheet with new columns.</p>
        <p><i>You will find information about the column types in Market Compare help.</i></p>
      `,
  },
  {
    title: 'Column Headers',
    element: 'semeris-column-list',
    intro: `
        <p><b>Sort</b> any column by clicking its header.</p>
        <p>The three-dot <i class="material-icons">more_vert</i> menus on each column offer additional functions:</p>
        <ul>
          <li><b>Filter</b> columns by typing in the search box.</li>
          <li>View <b>unique values</b> accompanied by indicative <b>statistics</b>.</li>
          <li>Access <b>actions</b> like editing datapoints and removing the column.</li>
        </ul>
      `,
  },
  {
    title: 'Packages by Semeris Analysts',
    intro: `
        <p>Our analysts have created ready-to-use <b>Topics</b> for CLOs and other asset classes. You will find them in Market Compare.</p>
        <p>For more information about <b>Market Compare</b>, tap <i class="material-icons">help_outline</i> in the top right corner.</p>
        <p><i>This concludes the tour. Happy analyzing!</i></p>
      `,
  },
];
